export default __webpack_public_path__ + "static/preschool6-85e23fe2e12b08882b7822a3b28fd2f2.jpg";